import { create } from 'zustand';
import type { ModerationAsset } from '../types';

interface ModerationDialogContext {
  asset: ModerationAsset;
  appType: string;
  /** Base URL for the smallapp microservice — sourced from `AppMeta.apiUrl`. */
  apiUrl: string;
  /** Resolves with the modal close payload — mirrors scio1 $uibModalInstance.close({ sortBy }). */
  resolve: (result: { sortBy: 'newest' | 'oldest' }) => void;
}

interface ModerationDialogState {
  context: ModerationDialogContext | null;
  isOpen: boolean;
  open: (context: ModerationDialogContext) => void;
  close: (result: { sortBy: 'newest' | 'oldest' }) => void;
}

/**
 * Imperative open/close controller for the moderation dialog.
 * Caller side: see `useModerationDialog()` in ../index.ts for the Promise-based API.
 */
export const useModerationDialogStore = create<ModerationDialogState>((set, get) => ({
  context: null,
  isOpen: false,
  open: (context) => set({ context, isOpen: true }),
  close: (result) => {
    const ctx = get().context;
    ctx?.resolve(result);
    set({ context: null, isOpen: false });
  },
}));
